import { Item } from "./Item";

export class Arma extends Item {
  dano: string = "";
  crit: string = "";
  alcance: string = "";
  tipo: string = "";
  proficiencia: string = "";
}
